import React, { FC, ReactNode, useEffect } from 'react';
import {
  Box,
  Grid,
  Pagination,
} from '@mui/material';

import { usePagination } from '@cvt/hooks/usePagination';
import { MessageFeedbackView } from '@cvt/components/MessageFeedbackView';
import { DEFAULT_QUERY_LIMIT } from '@cvt/helpers/query';

import { useMeetings } from '../hooks/useMeetings';


interface ViewProps {
  filters?: Meetings.GetListParams;
  renderItem: (meeting: Meetings.Meeting) => ReactNode;
}

export const MeetingList: FC<ViewProps> = ({ filters = {}, renderItem }) => {

  const { totalPages, setCount, page, setPage, limit, offset } = usePagination(filters.limit || DEFAULT_QUERY_LIMIT);

  const { count, meetings, status } = useMeetings({
    ...filters,
    offset,
    limit,
  });

  useEffect(() => {
    if (status === 'success') {
      setCount(count);
    }
  }, [status, setCount, count]);

  return (
    <React.Fragment>
      {status === 'error' && (
        <MessageFeedbackView height="100%"/>
      )}
      {status === 'success' && (
        <React.Fragment>
          {meetings.length === 0 && (
            <MessageFeedbackView height={400} message="No Meetings"/>
          )}
          {meetings.length > 0 && (
            <>
              <Grid container spacing={2}>
                {meetings.map(meeting => (
                  <Grid size={{ xs: 12 }} key={meeting.id}>
                    {renderItem(meeting)}
                  </Grid>
                ))}
              </Grid>
              {count > limit && (
                <Box display="flex" width="100%" p={2} mt="auto" justifyContent="center">
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={(event, value) => setPage(value)}
                    showFirstButton={page !== 1}
                    showLastButton={page !== totalPages}
                  />
                </Box>
              )}
            </>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
